module.exports = __webpack_public_path__ + "img/jtjkzxt2.2c6d5a4f.jpg";